import Axios from 'axios'

export const uploadFile = (file, uploadName = undefined) => {
    uploadName = uploadName || file.name
    return new Promise((resolve, reject) => {
        Axios.get(`/getuploadurl?filename=${uploadName}`)
            .then((res) => {
                if (!res.data) return reject('Failed to get upload URL.')

                const data = res.data
                const objectId = res.data.fields.key

                let fd = new FormData()
                Object.entries(res.data.fields).forEach(([k, v]) => {
                    fd.append(k, v)
                })
                fd.append('file', file) // must be last

                // Using fetch to avoid dealing with different domain
                fetch(data.url, { method: 'POST', body: fd }).then((resp) => {
                    if (resp.ok) {
                        return resolve(objectId)
                    } else {
                        return reject('Failed to upload file.')
                    }
                })
            })
            .catch((err) => {
                return reject(err)
            })
    })
}

export const downloadFile = (fileId, fileName) => {
    return new Promise((resolve, reject) => {
        Axios.get(fileId, {
            headers: {
                Accept:
                    'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9',
            },
            responseType: 'blob',
        })
            .then((res) => {
                var url = window.URL.createObjectURL(res.data)
                var a = document.createElement('a')
                a.href = url
                a.download = fileName
                document.body.appendChild(a) // otherwise it will not work in firefox
                a.click()
                a.remove()
                return resolve()
            })
            .catch((err) => {
                return reject(err)
            })
    })
}
